<template>
    <div class="root-box workflow-page">
        <el-tabs v-model="activeTab" @tab-click="onTabClick">

            <el-tab-pane label="全部" name="all">
                <workflow-process-list-pane scope="all" :query.sync="allProcQuery" :page.sync="allProcPage"
                    :loading="allProcLoading" :list="allProcList" :admin-options="adminOptions"
                    :workflow-tag-options="workflowTagOptions" :process-status-opts="processStatusOpts"
                    :related-party-role-opts="relatedPartyRoleOpts"
                    :list-filter-related-party-options="listFilterRelatedPartyOptions"
                    :list-filter-related-party-loading="listFilterRelatedPartyLoading"
                    :format-related-party="formatRelatedPartyCell" :can-edit-remark="canEditProcessRemarkOnly"
                    @reload="reloadProcessList('all')" @load="loadProcessList('all')"
                    @related-party-role-change="() => onListFilterRelatedPartyRoleChange('all')"
                    @open-create="openCreate" @detail="openDetail" @edit="openEdit" @remark="openRemarkOnlyDialog"
                    @logs="openProcessLogs" />
            </el-tab-pane>

            <el-tab-pane label="我发起的" name="mine">
                <workflow-process-list-pane scope="mine" :query.sync="procQuery" :page.sync="procPage"
                    :loading="procLoading" :list="procList" :admin-options="adminOptions"
                    :workflow-tag-options="workflowTagOptions" :process-status-opts="processStatusOpts"
                    :related-party-role-opts="relatedPartyRoleOpts"
                    :list-filter-related-party-options="listFilterRelatedPartyOptions"
                    :list-filter-related-party-loading="listFilterRelatedPartyLoading"
                    :format-related-party="formatRelatedPartyCell" :can-edit-remark="canEditProcessRemarkOnly"
                    @reload="reloadProcessList('mine')" @load="loadProcessList('mine')"
                    @related-party-role-change="() => onListFilterRelatedPartyRoleChange('mine')"
                    @open-create="openCreate" @detail="openDetail" @edit="openEdit" @remark="openRemarkOnlyDialog"
                    @logs="openProcessLogs" />
            </el-tab-pane>

            <el-tab-pane label="我的待办" name="todo">
                <el-table v-loading="todoLoading" :data="todoList" stripe max-height="560" size="small">
                    <el-table-column type="index" width="50" label="#" />
                    <el-table-column prop="id" label="任务ID" width="90" />
                    <el-table-column prop="processId" label="流程ID" width="90" />
                    <el-table-column prop="processQuestionTitle" label="主标题" min-width="160" show-overflow-tooltip />
                    <el-table-column prop="title" label="标题" min-width="160" show-overflow-tooltip />
                    <el-table-column prop="description" label="描述" min-width="260" show-overflow-tooltip />
                    <el-table-column label="执行人" width="110" show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.assigneeId | enumTransfer(adminOptions, 'id',
                            'name') }}</template>
                    </el-table-column>
                    <el-table-column label="状态" width="100">
                        <template slot-scope="scope">{{ scope.row.status | enumTransfer(taskStatusOpts) }}</template>
                    </el-table-column>
                    <el-table-column prop="deadline" label="截止时间" width="160">
                        <template slot-scope="scope">{{ scope.row.deadline || "-" }}</template>
                    </el-table-column>
                    <el-table-column prop="processingStartedAt" label="开始处理" width="160">
                        <template slot-scope="scope">
                            {{ scope.row.processingStartedAt || "-" }}</template>
                    </el-table-column>
                    <el-table-column prop="createdAt" label="创建时间" width="160">
                        <template slot-scope="scope">{{ scope.row.createdAt || "-" }}</template>
                    </el-table-column>
                    <el-table-column label="操作" width="260" fixed="right">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" :disabled="!scope.row.processId"
                                @click="openDetail(scope.row.processId)">详情</el-button>
                            <el-button v-if="canStartProcessingTask(scope.row)" type="text" size="small"
                                @click="submitStartProcessing(scope.row)">开始处理</el-button>
                            <el-button type="text" size="small" :disabled="!canCompleteWorkflowTask(scope.row)"
                                @click="openComplete(scope.row)">处理</el-button>
                            <!-- <el-button type="text" size="small" @click="openSplit(scope.row)">拆分</el-button> -->
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination class="pager" background layout="total, prev, pager, next, sizes"
                    :page-sizes="[10, 20, 50]" :current-page.sync="todoPage.current" :page-size.sync="todoPage.size"
                    :total="todoPage.total" @size-change="reloadTodo" @current-change="loadTodo" />
            </el-tab-pane>
        </el-tabs>

        <!-- 修改流程 -->
        <el-dialog :title="editingProcessIsTempSave ? '修改暂存流程' : '修改流程'" :visible.sync="processDialogVisible"
            width="720px" :close-on-click-modal="false" append-to-body>
            <div>
                <el-form ref="processForm" :key="editingProcessId" :model="processForm" :rules="processFormRules"
                    label-width="100px" size="small">
                    <el-form-item label="问题标题" prop="questionTitle">
                        <el-input v-model="processForm.questionTitle" maxlength="255" show-word-limit />
                    </el-form-item>
                    <el-form-item label="问题描述" prop="questionDescription">
                        <el-input v-model="processForm.questionDescription" type="textarea" :rows="4" />
                    </el-form-item>
                    <el-form-item label="流程标签" prop="tag">
                        <el-select v-model="processForm.tag" placeholder="请选择标签" style="width: 100%">
                            <el-option v-for="(tag, idx) in workflowTagOptions" :key="idx" :label="tag" :value="tag" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="附件">
                        <multiple-file-upload v-model="processForm.questionAttachments" file-path="/workflow/question"
                            :limit="10" paste-upload :paste-capture="processDialogVisible"
                            upload-tip="支持点击上传或在窗口内 Ctrl+V / Cmd+V 粘贴剪贴板文件（含截图），单个文件不超过20MB，最多10个" />
                    </el-form-item>
                    <el-form-item label="业务附件">
                        <AttachmentSelector v-model="processForm.bizAttachments" multiple />
                    </el-form-item>
                    <el-row :gutter="12" class="related-party-form-row">
                        <el-col :span="12">
                            <el-form-item label="关联方角色" prop="relatedPartyRole">
                                <el-select v-model="processForm.relatedPartyRole" clearable filterable
                                    placeholder="请选择角色" style="width: 100%" @change="onRelatedPartyRoleChange">
                                    <el-option v-for="(opt, idx) in relatedPartyRoleOpts" :key="idx" :label="opt.label"
                                        :value="opt.value" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="关联方" prop="relatedPartyId">
                                <el-select v-model="processForm.relatedPartyId" filterable clearable
                                    placeholder="请选择关联方" style="width: 100%" :disabled="!processForm.relatedPartyRole"
                                    v-loading="relatedPartySearchLoading">
                                    <el-option v-for="item in relatedPartyOptions" :key="item.relatedPartyId"
                                        :label="item.relatedPartyName" :value="item.relatedPartyId" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <template v-if="editingProcessIsTempSave">
                        <el-form-item label="处理人" prop="firstAssigneeId">
                            <el-select v-model="processForm.firstAssigneeId" filterable placeholder="请选择后台用户"
                                style="width: 100%" @change="onProcessAssigneeChange">
                                <el-option v-for="u in adminOptions" :key="u.id" :label="formatAdminLabel(u)"
                                    :value="u.id" />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="截止时间" prop="deadline">
                            <el-date-picker v-model="processForm.deadline" type="datetime" placeholder="选择截止时间"
                                value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm" style="width: 100%" />
                        </el-form-item>
                    </template>
                </el-form>
            </div>
            <span slot="footer">
                <el-button size="small" @click="processDialogVisible = false">取 消</el-button>
                <template v-if="editingProcessIsTempSave">
                    <el-button size="small" :loading="processTempSaveSubmitting" @click="submitProcessTempSave">暂
                        存</el-button>
                    <el-button type="primary" size="small" :loading="processSubmitting" @click="submitProcess">提
                        交</el-button>
                </template>
                <el-button v-else type="primary" size="small" :loading="processSubmitting" @click="submitProcess">保
                    存</el-button>
            </span>
        </el-dialog>

        <!-- 流程详情 -->
        <el-dialog title="流程详情" :visible.sync="detailVisible" width="900px" top="5vh" :close-on-click-modal="false"
            append-to-body destroy-on-close custom-class="workflow-detail-dialog">
            <div v-loading="detailLoading">
                <template v-if="detail">
                    <h4 class="sec-title">基本信息</h4>
                    <el-descriptions :column="2" border size="small">
                        <el-descriptions-item label="流程编号">{{ detail.process.processNo }}</el-descriptions-item>
                        <el-descriptions-item label="状态">{{ detail.process.status | enumTransfer(processStatusOpts)
                        }}</el-descriptions-item>
                        <el-descriptions-item label="流程标签">{{ detail.process.tag || "-" }}</el-descriptions-item>
                        <el-descriptions-item label="关联方">{{ detail.process.relatedPartyRole |
                            enumTransfer(relatedPartyRoleOpts)
                        }} {{ detail.process.relatedPartyName || "-"
                            }}</el-descriptions-item>
                        <el-descriptions-item label="标题">{{ detail.process.questionTitle
                        }}</el-descriptions-item>
                        <el-descriptions-item label="创建人">{{ detail.process.initiatorId | enumTransfer(adminOptions,
                            'id', 'name') }}</el-descriptions-item>
                        <el-descriptions-item label="创建时间">
                            {{ detail.process.createdAt || "-" }}
                        </el-descriptions-item>
                        <el-descriptions-item label="截止时间">
                            {{ detail.process.deadline || "-" }}
                        </el-descriptions-item>
                        <el-descriptions-item label="描述" :span="2">{{ detail.process.questionDescription
                        }}</el-descriptions-item>
                        <el-descriptions-item label="备注" :span="2">{{ detail.process.remark || "-"
                        }}</el-descriptions-item>


                        <el-descriptions-item label="附件" :span="2">
                            <multiple-file-display :files="detail.process.questionAttachments" :readonly="true" />
                        </el-descriptions-item>
                        <el-descriptions-item label="业务附件" :span="2">
                            <AttachmentSelector v-model="detail.process.bizAttachments" multiple readonly />
                        </el-descriptions-item>
                    </el-descriptions>

                    <h4 class="sec-title">任务树</h4>
                    <el-tree v-if="taskTreeData.length" :data="taskTreeData" :props="treeProps" default-expand-all
                        class="workflow-task-tree">
                        <span class="task-tree-node" slot-scope="{ data }">
                            <span class="task-tree-node__main"
                                :class="{ 'task-tree-node__main--overdue': isTaskDeadlineOverdue(data.task) }">
                                <template v-if="data.task">
                                    {{ buildTaskTreeLineBeforeAssignee(data.task) }}<span
                                        class="task-tree-node__assignee task-tree-node__assignee--link"
                                        role="presentation" @click.stop="onTaskTreeAssigneeClick(data.task)">{{
                                            taskTreeAssigneeDisplay(data.task) }}</span>
                                </template>
                            </span>
                            <span v-if="data.task && hasTaskDeadline(data.task)" class="task-tree-node__deadline"
                                :class="{ 'task-tree-node__deadline--overdue': isTaskDeadlineOverdue(data.task) }">
                                截止日期： {{ data.task.deadline || "-" }}
                                <template v-if="isTaskDeadlineOverdue(data.task)">（已逾期）</template>
                            </span>
                            <el-button type="text" size="mini" class="task-tree-node__detail-btn"
                                @click.stop="openTaskTreeDetail(data.task)">任务详情</el-button>
                        </span>
                    </el-tree>
                    <div v-else class="empty-tip">暂无任务</div>

                    <div v-if="taskTreeDetailTask" class="task-tree-detail-panel">
                        <h4 class="sec-title">
                            任务详情
                            <span class="task-tree-detail-panel__sub">#{{ taskTreeDetailTask.id }} · {{
                                taskTreeDetailTask.title }}</span>
                        </h4>
                        <el-descriptions :column="1" border size="small" class="task-tree-detail-panel__desc">
                            <el-descriptions-item label="任务说明">
                                <div class="task-tree-detail-panel__text">{{ taskTreeDetailTask.description || "—" }}
                                </div>
                            </el-descriptions-item>
                            <el-descriptions-item label="附件">
                                <multiple-file-display :files="taskTreeDetailTask.attachments || []" />
                            </el-descriptions-item>
                            <el-descriptions-item label="业务附件">
                                <AttachmentSelector :value="taskTreeDetailTask.bizAttachments || []" multiple
                                    readonly />
                            </el-descriptions-item>
                            <el-descriptions-item label="处理意见">
                                <div class="task-tree-detail-panel__text">{{ taskTreeDetailTask.resultComment }}
                                </div>
                            </el-descriptions-item>
                            <el-descriptions-item label="处理结果附件">
                                <multiple-file-display :files="taskTreeDetailTask.resultAttachments || []" />
                            </el-descriptions-item>
                            <el-descriptions-item label="处理业务附件">
                                <AttachmentSelector :value="taskTreeDetailTask.resultBizAttachments || []" multiple
                                    readonly />
                            </el-descriptions-item>
                            <el-descriptions-item label="开始处理时间">
                                {{ taskTreeDetailTask.processingStartedAt || "-" }}
                            </el-descriptions-item>
                            <el-descriptions-item label="处理时长">
                                {{ formatProcessingDuration(taskTreeDetailTask.processingDurationSeconds) }}
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>
                </template>
            </div>
        </el-dialog>

        <!-- 流程操作日志 -->
        <el-dialog :title="processLogTitle" :visible.sync="processLogVisible" width="900px" top="8vh"
            :close-on-click-modal="false" append-to-body custom-class="workflow-log-dialog">
            <div v-loading="processLogLoading">
                <el-table :data="processLogs" size="small" max-height="420" stripe>
                    <el-table-column prop="createdAt" label="时间" width="160">
                        <template slot-scope="scope">{{ scope.row.createdAt || "-" }}</template>
                    </el-table-column>
                    <el-table-column label="动作" width="120">
                        <template slot-scope="scope">{{ scope.row.action | enumTransfer(actionOpts) }}</template>
                    </el-table-column>
                    <el-table-column label="处理人" width="100">
                        <template slot-scope="scope">{{ scope.row.operatorId | enumTransfer(adminOptions, 'id',
                            'name') }}</template>
                    </el-table-column>
                    <el-table-column label="前状态" width="100">
                        <template slot-scope="scope">{{ scope.row.beforeStatus | enumTransfer(taskStatusOpts)
                            }}</template>
                    </el-table-column>
                    <el-table-column label="后状态" width="100">
                        <template slot-scope="scope">{{ scope.row.afterStatus | enumTransfer(taskStatusOpts)
                            }}</template>
                    </el-table-column>
                    <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip />
                </el-table>
            </div>
        </el-dialog>

        <!-- 处理任务 -->
        <el-dialog title="处理任务" :visible.sync="completeVisible" width="640px" :close-on-click-modal="false"
            append-to-body>
            <template v-if="completeCtx.task">
                <div class="complete-task-header">
                    <div class="complete-task-header__title">{{ completeCtx.task.title || "—" }}</div>
                    <div class="complete-task-header__meta">
                        <span class="complete-task-header__deadline-link" role="button" tabindex="0"
                            :class="{ 'complete-task-header__deadline-overdue': isTaskDeadlineOverdue(completeCtx.task) }"
                            @click="openCompleteTaskDeadlineDialog">
                            截止日期： {{ completeCtx.task.deadline || "-" }}
                        </span>
                    </div>
                </div>
                <div class="complete-task-source">
                    <div class="complete-task-source__caption">派发内容</div>
                    <el-descriptions :column="1" border size="small" class="complete-task-source__desc">
                        <el-descriptions-item label="任务说明">
                            <div class="complete-task-source__pre">{{ completeCtx.task.description }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="任务附件">
                            <multiple-file-display :files="completeCtx.task.attachments || []" />
                        </el-descriptions-item>
                        <el-descriptions-item label="业务附件">
                            <AttachmentSelector :value="completeCtx.task.bizAttachments || []" multiple readonly />
                        </el-descriptions-item>
                    </el-descriptions>
                </div>
                <el-divider content-position="left">处理反馈</el-divider>
            </template>
            <el-form ref="completeForm" :model="completeForm" label-width="110px" size="small">
                <div class="complete-task-mode-bar">
                    <el-form-item label="指派他人处理" class="complete-task-mode-bar__switch">
                        <el-switch v-model="completeForm.enableNext" :disabled="disableCompleteNext" active-text="是"
                            inactive-text="否" @change="onCompleteEnableNextChange" />
                    </el-form-item>
                    <el-form-item v-if="completeForm.enableNext" label="" label-width="0"
                        class="complete-task-mode-bar__checkbox-item">
                        <el-checkbox v-model="completeForm.goOnByMyselfIfHasNextTask"
                            class="complete-task-mode-bar__checkbox">
                            完成后我继续处理
                        </el-checkbox>
                    </el-form-item>
                </div>
                <div class="complete-task-feedback-panel">
                    <div class="complete-task-feedback-panel__caption">
                        {{ completeForm.enableNext ? "转派信息" : "本人处理反馈" }}
                    </div>
                    <template v-if="completeForm.enableNext">
                        <el-form-item label="下一处理人" required>
                            <el-select v-model="completeForm.nextAssigneeId" filterable placeholder="请选择"
                                style="width: 100%" @change="onNextAssigneeChange">
                                <el-option v-for="u in adminOptions" :key="u.id" :label="formatAdminLabel(u)"
                                    :value="u.id" />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="附件">
                            <multiple-file-upload v-model="completeForm.resultAttachments"
                                file-path="/workflow/task-result" :limit="10" paste-upload
                                :paste-capture="completeVisible && !completeForm.enableNext"
                                upload-tip="支持点击上传或在窗口内 Ctrl+V / Cmd+V 粘贴剪贴板文件（含截图），单个文件不超过20MB，最多10个" />
                        </el-form-item>
                        <el-form-item label="业务附件">
                            <AttachmentSelector v-model="completeForm.resultBizAttachments" multiple />
                        </el-form-item>
                        <el-form-item label="后续任务标题">
                            <el-input v-model="completeForm.nextTitle" placeholder="待处理" />
                        </el-form-item>
                        <el-form-item label="后续任务说明">
                            <el-input v-model="completeForm.nextDescription" type="textarea" :rows="2" />
                        </el-form-item>
                        <el-form-item label="后续截止时间">
                            <el-date-picker v-model="completeForm.nextDeadline" type="datetime" placeholder="选择截止时间（可选）"
                                value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm" style="width: 100%" />
                        </el-form-item>
                    </template>
                    <template v-else>
                        <el-form-item label="处理方式" prop="handleType">
                            <div class="complete-deal-type-row">
                                <el-select v-model="completeForm.handleType" clearable placeholder="请选择"
                                    class="complete-deal-type-row__select" @change="onCompleteHandleTypeChange">
                                    <el-option v-for="u in completeHandleTypeOpts" :key="u.value" :label="u.label"
                                        :value="u.value" />
                                </el-select>
                                <el-button v-if="completeForm.handleType === 'DRIVER_NOTICE'" type="primary"
                                    size="small" plain @click="onWorkflowSendNotice">发通知</el-button>
                                <el-button v-if="completeForm.handleType === 'DRIVER_PUNISHMENT'" type="primary"
                                    size="small" plain @click="onWorkflowOpenPunish">开罚单</el-button>
                            </div>
                            <div v-if="completeForm.handleBizId" class="complete-handle-biz-id muted">
                                已关联业务ID：{{ completeForm.handleBizId }}
                            </div>
                        </el-form-item>

                        <el-form-item label="处理结果">
                            <el-input v-model="completeForm.resultComment" type="textarea" :rows="3" />
                        </el-form-item>
                        <el-form-item label="附件">
                            <multiple-file-upload v-model="completeForm.resultAttachments"
                                file-path="/workflow/task-result" :limit="10" paste-upload
                                :paste-capture="completeVisible && !completeForm.enableNext"
                                upload-tip="支持点击上传或在窗口内 Ctrl+V / Cmd+V 粘贴剪贴板文件（含截图），单个文件不超过20MB，最多10个" />
                        </el-form-item>
                        <el-form-item label="业务附件">
                            <AttachmentSelector v-model="completeForm.resultBizAttachments" multiple />
                        </el-form-item>
                    </template>
                </div>
            </el-form>
            <span slot="footer">
                <el-button size="small" @click="completeVisible = false">取 消</el-button>
                <el-button type="primary" size="small" :loading="completeSubmitting" @click="submitComplete">提
                    交</el-button>
            </span>
        </el-dialog>

        <el-dialog title="修改截止时间" :visible.sync="taskDeadlineDialogVisible" width="440px" :close-on-click-modal="false"
            append-to-body>
            <el-date-picker v-model="taskDeadlinePicker" type="datetime" placeholder="选择截止时间"
                format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%" />
            <span slot="footer">
                <el-button size="small" @click="taskDeadlineDialogVisible = false">取 消</el-button>
                <el-button type="primary" size="small" :loading="taskDeadlineSaving"
                    @click="submitCompleteTaskDeadline">确
                    定</el-button>
            </span>
        </el-dialog>

        <!-- 详情任务树：修改当前处理人（是否允许以后台校验为准） -->
        <el-dialog title="修改当前处理人" :visible.sync="treeAssigneeDialogVisible" width="460px" :close-on-click-modal="false"
            append-to-body @closed="onTreeAssigneeDialogClosed">
            <el-select v-model="treeAssigneeForm.assigneeId" filterable placeholder="请选择处理人" style="width: 100%">
                <el-option v-for="u in adminOptions" :key="u.id" :label="formatAdminLabel(u)" :value="u.id" />
            </el-select>
            <span slot="footer">
                <el-button size="small" @click="treeAssigneeDialogVisible = false">取 消</el-button>
                <el-button type="primary" size="small" :loading="treeAssigneeSaving"
                    @click="submitTaskAssigneeReassign">确
                    定</el-button>
            </span>
        </el-dialog>

        <!-- 拆分任务 -->
        <el-dialog title="拆分子任务" :visible.sync="splitVisible" width="1200px" :close-on-click-modal="false"
            append-to-body>
            <el-alert type="info" show-icon :closable="false" title="至少 2 个子任务；全部完成后原任务将回到您的待办中。"
                style="margin-bottom: 12px" />
            <el-form label-width="110px" size="small">
                <el-form-item label="子任务列表">
                    <el-table :data="splitForm.subTasks" size="small" border>
                        <el-table-column label="执行人" min-width="180">
                            <template slot-scope="scope">
                                <el-select v-model="scope.row.assigneeId" filterable placeholder="选择"
                                    style="width: 100%" @change="(v) => onSubAssigneeChange(scope.row, v)">
                                    <el-option v-for="u in adminOptions" :key="u.id" :label="formatAdminLabel(u)"
                                        :value="u.id" />
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column label="标题" min-width="120">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.title" placeholder="子任务" />
                            </template>
                        </el-table-column>
                        <el-table-column label="说明" min-width="200">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.description" type="textarea" :rows="2" />
                            </template>
                        </el-table-column>
                        <el-table-column label="截止时间" min-width="170">
                            <template slot-scope="scope">
                                <el-date-picker v-model="scope.row.deadline" type="datetime" placeholder="截止时间"
                                    value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm" style="width: 100%"
                                    size="small" />
                            </template>
                        </el-table-column>
                        <el-table-column label="附件" min-width="300">
                            <template slot-scope="scope">
                                <multiple-file-upload v-model="scope.row.attachments" :readonly="true" />
                            </template>
                        </el-table-column>
                        <el-table-column label="业务附件" min-width="300">
                            <template slot-scope="scope">
                                <AttachmentSelector v-model="scope.row.bizAttachments" multiple />
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="70" fixed="right">
                            <template slot-scope="scope">
                                <el-button type="text" size="small" :disabled="splitForm.subTasks.length <= 2"
                                    @click="removeSubTask(scope.$index)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-button type="text" icon="el-icon-plus" @click="addSubTask">添加子任务</el-button>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button size="small" @click="splitVisible = false">取 消</el-button>
                <el-button type="primary" size="small" :loading="splitSubmitting" @click="submitSplit">提 交</el-button>
            </span>
        </el-dialog>

        <!-- 仅修改备注 -->
        <el-dialog title="修改备注" :visible.sync="remarkOnlyDialogVisible" width="520px" :close-on-click-modal="false"
            append-to-body @closed="onRemarkOnlyDialogClosed">
            <el-input v-model="remarkOnlyForm.remark" type="textarea" :rows="5" maxlength="500" show-word-limit
                placeholder="可填写便于检索的说明" size="small" />
            <span slot="footer">
                <el-button size="small" @click="remarkOnlyDialogVisible = false">取 消</el-button>
                <el-button type="primary" size="small" :loading="remarkOnlySubmitting" @click="submitRemarkOnly">保
                    存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { USER_INFO } from "@/core/const/global-const";
import { SHOW_DRIVER_NOTICE_MODAL, SHOW_PUNISH_DIAG, SHOW_WORKFLOW_CREATE_MODAL } from "@/core/const/global-event";
import { LocalStorage, DateUtil, Toolkit } from "@/util";
import { getAdminList } from "@/api/admin";
import _ from "lodash";
import {
    getWorkflowProcessList,
    getWorkflowTaskTodo,
    getWorkflowRelatedParties,
    updateWorkflowProcess,
    updateWorkflowProcessRemark,
    getWorkflowProcessDetail,
    getWorkflowHandleTypesByProcessId,
    getWorkflowPunishBillByProcess,
    completeWorkflowTask,
    splitWorkflowTask,
    startWorkflowTaskProcessing,
    updateWorkflowTaskDeadline,
    reassignWorkflowTaskAssignee
} from "@/api/workflow";
import AttachmentSelector from "@/components/AttachmentSelector";
import WorkflowProcessListPane from "./WorkflowProcessListPane";
import { BaseDataService } from "@/service";

/** 列表默认创建日期：最近 7 个自然日（含今天） */
function defaultWorkflowCreatedDateRange() {
    const end = new Date();
    const start = new Date();
    start.setDate(start.getDate() - 6);
    return [DateUtil.format(start, "yyyy-MM-dd"), DateUtil.format(end, "yyyy-MM-dd")];
}

export default {
    name: "WorkFlowPage",
    components: { AttachmentSelector, WorkflowProcessListPane },
    data() {
        return {
            activeTab: "mine",
            adminOptions: [{ id: -1, name: "系统" }],
            relatedPartyOptions: [],
            relatedPartySearchLoading: false,
            workflowTagOptions: BaseDataService.workflowTagOpts(),
            listFilterRelatedPartyOptions: [],
            listFilterRelatedPartyLoading: false,
            procQuery: {
                statusList: [],
                createdAtRange: defaultWorkflowCreatedDateRange(),
                relatedPartyRole: null,
                relatedPartyId: null,
                currentHandlerId: null,
                remarkKeyword: ""
            },
            procLoading: false,
            procList: [],
            procPage: { current: 1, size: 10, total: 0 },
            allProcQuery: {
                initiatorId: null,
                statusList: [],
                tag: "",
                createdAtRange: defaultWorkflowCreatedDateRange(),
                relatedPartyRole: null,
                relatedPartyId: null,
                currentHandlerId: null,
                remarkKeyword: ""
            },
            allProcLoading: false,
            allProcList: [],
            allProcPage: { current: 1, size: 10, total: 0 },
            todoLoading: false,
            todoList: [],
            todoPage: { current: 1, size: 10, total: 0 },
            /** 修改流程弹窗 */
            processDialogVisible: false,
            processSubmitting: false,
            processTempSaveSubmitting: false,
            editingProcessId: null,
            processForm: {

            },
            detailVisible: false,
            detailLoading: false,
            detail: null,
            processLogVisible: false,
            processLogLoading: false,
            processLogs: [],
            processLogTitle: "操作日志",
            treeProps: { children: "children", label: "label" },
            /** 流程详情任务树：当前选中的任务，在树下方展示详情 */
            taskTreeDetailTask: null,
            completeVisible: false,
            completeSubmitting: false,
            taskDeadlineDialogVisible: false,
            taskDeadlinePicker: null,
            taskDeadlineSaving: false,
            completeCtx: { task: null },
            /** 办结任务：处理方式下拉（接口按 processId 返回） */
            completeHandleTypeOpts: [],
            completeForm: {
                handleType: null,
                handleBizId: "",
                resultComment: "",
                resultAttachments: [],
                resultBizAttachments: [],
                enableNext: false,
                goOnByMyselfIfHasNextTask: false,
                nextAssigneeId: null,
                nextAssigneeName: "",
                nextTitle: "",
                nextDescription: "",
                nextDeadline: null
            },
            splitVisible: false,
            splitSubmitting: false,
            splitCtx: { taskId: null, parentDeadline: null },
            splitForm: {
                subTasks: []
            },
            /** 仅改备注弹窗 */
            remarkOnlyDialogVisible: false,
            remarkOnlySubmitting: false,
            remarkOnlyForm: {
                id: null,
                remark: ""
            },
            /** 详情任务树：修改执行人 */
            treeAssigneeDialogVisible: false,
            treeAssigneeSaving: false,
            treeAssigneeForm: {
                taskId: null,
                assigneeId: null
            }
        };
    },
    computed: {
        ...mapState({
            processStatusOpts: (state) => state.enumMap["WORKFLOW_PROCESS_STATUS"] || [],
            taskStatusOpts: (state) => state.enumMap["WORKFLOW_TASK_STATUS"] || [],
            actionOpts: (state) => state.enumMap["WORKFLOW_OPERATION_ACTION"] || [],
            relatedPartyRoleOpts: (state) => state.enumMap["WORKFLOW_RELATED_PARTY_ROLE"] || []
        }),
        taskTreeData() {
            if (!this.detail || !this.detail.taskTree) return [];
            return this.mapTaskTree(this.detail.taskTree);
        },
        processFormRules() {
            const rules = {
                questionTitle: [{ required: true, message: "请输入标题", trigger: "blur" }],
                tag: [{ required: true, message: "请选择流程标签", trigger: "change" }]
            };
            if (this.editingProcessIsTempSave) {
                rules.firstAssigneeId = [{ required: true, message: "请选择处理人", trigger: "change" }];
            }
            return rules;
        },
        editingProcessIsTempSave() {
            return this.processForm && this.processForm.status === "TEMP_SAVE";
        },
        disableCompleteNext() {
            return this.completeCtx.task && this.completeCtx.task.noNeedNext;
        }
    },
    created() {
        const tab = this.$route.query.tab;
        if (tab === "todo" || tab === "mine" || tab === "all") {
            this.activeTab = tab;
        }

        this.loadAdminList();
        this.onTabClick({ name: this.activeTab });
    },
    methods: {
        /** 表格「关联方」列：角色 + 名称合并展示 */
        formatRelatedPartyCell(row) {
            if (!row) return "-";
            const f = this.$options.filters.enumTransfer;
            const roleTxt = row.relatedPartyRole
                ? f(row.relatedPartyRole, this.relatedPartyRoleOpts)
                : "";
            const name = (row.relatedPartyName || "").trim();
            if (!roleTxt && !name) return "-";
            if (!roleTxt) return name;
            if (!name) return roleTxt;
            return `${roleTxt} / ${name}`;
        },
        formatAdminLabel(u) {
            return `${u.name || ""}`;
        },
        /** 是否为当前用户发起的、进行中流程（可改备注） */
        canEditProcessRemarkOnly(row) {
            if (!row) return false;
            const user = LocalStorage.get(USER_INFO) || {};
            if (user.id == null || user.id === "") return false;
            if (Number(row.initiatorId) !== Number(user.id)) return false;
            const s = row.status;
            return s === "PENDING" || s === "IN_PROGRESS";
        },
        openRemarkOnlyDialog(row) {
            if (!row || !row.id) return;
            this.remarkOnlyForm = {
                id: row.id,
                remark: row.remark != null ? String(row.remark) : ""
            };
            this.remarkOnlyDialogVisible = true;
        },
        onRemarkOnlyDialogClosed() {
            this.remarkOnlyForm = { id: null, remark: "" };
        },
        submitRemarkOnly() {
            if (!this.remarkOnlyForm.id) return;
            this.remarkOnlySubmitting = true;
            updateWorkflowProcessRemark({
                id: this.remarkOnlyForm.id,
                remark: this.remarkOnlyForm.remark
            })
                .then(() => {
                    this.$message.success("保存成功");
                    const pid = this.remarkOnlyForm.id;
                    this.remarkOnlyDialogVisible = false;
                    this.refreshWorkflowProcessGrids();
                    if (
                        this.detailVisible &&
                        this.detail &&
                        this.detail.process &&
                        this.detail.process.id === pid
                    ) {
                        this.openDetail(pid);
                    }
                })
                .finally(() => {
                    this.remarkOnlySubmitting = false;
                });
        },
        mapTaskTree(nodes) {
            return (nodes || []).map((n) => ({
                id: n.task && n.task.id,
                task: n.task,
                label: this.buildTaskTreeLineMain(n.task),
                children: this.mapTaskTree(n.children || [])
            }));
        },
        /** 任务树节点主文案（不含截止时间，截止时间在模板中单独样式展示） */
        buildTaskTreeLineMain(task) {
            if (!task) return "";
            const f = this.$options.filters.enumTransfer;
            const statusTxt = f(task.status, this.taskStatusOpts);
            const assigneeTxt = f(task.assigneeId, this.adminOptions, "id", "name");
            return `${task.title} ｜ ${statusTxt} ｜ 执行人：${assigneeTxt}`;
        },
        /** 任务树行：执行人名称之前的片段（便于执行人名单独可点） */
        buildTaskTreeLineBeforeAssignee(task) {
            if (!task) return "";
            const f = this.$options.filters.enumTransfer;
            const statusTxt = f(task.status, this.taskStatusOpts);
            return `${task.title} ｜ ${statusTxt} ｜ 执行人：`;
        },
        /** 详情任务树的执行人展示名 */
        taskTreeAssigneeDisplay(task) {
            if (!task) return "";
            const f = this.$options.filters.enumTransfer;
            const name = f(task.assigneeId, this.adminOptions, "id", "name");
            return name != null && name !== "" ? name : "-";
        },
        onTaskTreeAssigneeClick(task) {
            if (!task || task.id == null) return;
            this.treeAssigneeForm = {
                taskId: task.id != null ? task.id : null,
                assigneeId: task.assigneeId != null ? task.assigneeId : null
            };
            this.treeAssigneeDialogVisible = true;
        },
        onTreeAssigneeDialogClosed() {
            this.treeAssigneeForm = { taskId: null, assigneeId: null };
        },
        submitTaskAssigneeReassign() {
            const fid = this.treeAssigneeForm.taskId;
            const aid = this.treeAssigneeForm.assigneeId;
            if (!fid || aid === null || aid === undefined || aid === "") {
                this.$message.warning("请选择处理人");
                return;
            }
            this.treeAssigneeSaving = true;
            reassignWorkflowTaskAssignee({ taskId: fid, assigneeId: aid })
                .then(() => {
                    this.$message.success("已修改当前处理人");
                    this.treeAssigneeDialogVisible = false;
                    const pid = this.detail && this.detail.process ? this.detail.process.id : null;
                    if (pid) {
                        this.openDetail(pid);
                    }
                })
                .finally(() => {
                    this.treeAssigneeSaving = false;
                });
        },
        hasTaskDeadline(task) {
            if (!task) return false;
            const d = task.deadline;
            return d !== undefined && d !== null && d !== "";
        },
        /** 当前时间已超过 deadline 则视为逾期（与任务是否已完成无关，便于看出曾逾期） */
        isTaskDeadlineOverdue(task) {
            if (!this.hasTaskDeadline(task)) return false;
            const t = this.parseDeadlineToTime(task.deadline);
            if (t == null) return false;
            return Date.now() > t;
        },
        parseDeadlineToTime(v) {
            if (v === undefined || v === null || v === "") return null;
            if (typeof v === "number" && !Number.isNaN(v)) return v;
            const s = String(v).trim();
            if (!s) return null;
            const normalized = s.includes("T") ? s : s.replace(" ", "T");
            const ms = Date.parse(normalized);
            return Number.isNaN(ms) ? null : ms;
        },
        openTaskTreeDetail(task) {
            this.taskTreeDetailTask = task || null;
        },
        /** 新建流程/任务默认截止时间：当前时刻起 24 小时（与后端 default 一致） */
        defaultWorkflowDeadline() {
            const d = new Date();
            d.setDate(d.getDate() + 1);
            return DateUtil.format(d, "yyyy-MM-dd hh:mm:ss");
        },
        /** 后端写入的 processingDurationSeconds */
        formatProcessingDuration(sec) {
            if (sec === undefined || sec === null || sec === "") {
                return "—";
            }
            const n = Number(sec);
            if (!Number.isFinite(n) || n < 0) {
                return "—";
            }
            if (n < 60) {
                return `${n} 秒`;
            }
            const m = Math.floor(n / 60);
            const s = n % 60;
            if (m < 60) {
                return s ? `${m} 分 ${s} 秒` : `${m} 分钟`;
            }
            const h = Math.floor(m / 60);
            const m2 = m % 60;
            return m2 ? `${h} 小时 ${m2} 分` : `${h} 小时`;
        },
        canStartProcessingTask(row) {
            return row && row.status === "PENDING";
        },
        canCompleteWorkflowTask(row) {
            const s = row && row.status;
            return s === "PENDING" || s === "IN_PROGRESS" || s === "TIMEOUT";
        },
        submitStartProcessing(row) {
            if (!row || !row.id) return;
            this.$confirm('确定开始处理吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                startWorkflowTaskProcessing(row.id).then(() => {
                    this.$message.success("已开始处理");
                    this.loadTodo();
                });
            });
        },
        openCompleteTaskDeadlineDialog() {
            if (!this.completeCtx.task) return;
            this.taskDeadlinePicker = this.completeCtx.task.deadline || this.defaultWorkflowDeadline();
            this.taskDeadlineDialogVisible = true;
        },
        submitCompleteTaskDeadline() {
            const t = this.completeCtx.task;
            if (!t || !t.id) return;
            if (!this.taskDeadlinePicker) {
                this.$message.warning("请选择截止时间");
                return;
            }
            this.taskDeadlineSaving = true;
            updateWorkflowTaskDeadline({ id: t.id, deadline: this.taskDeadlinePicker })
                .then(() => {
                    this.$message.success("截止时间已更新");
                    this.$set(this.completeCtx.task, "deadline", this.taskDeadlinePicker);
                    this.taskDeadlineDialogVisible = false;
                    this.loadTodo();
                })
                .finally(() => {
                    this.taskDeadlineSaving = false;
                });
        },
        loadAdminList() {
            const param = {
                page: { size: 500 }, param: {
                    normalUser: true
                }
            };
            getAdminList(param).then((res) => {
                const list = res.data.records || [];
                list.unshift({ id: -1, name: "系统" });
                this.adminOptions = list;
            });
        },
        onTabClick(tab) {
            if (tab.name === "mine") this.loadProcessList("mine");
            if (tab.name === "all") this.loadProcessList("all");
            if (tab.name === "todo") this.loadTodo();
        },
        resetPageAndLoad(page, loadFn) {
            page.current = 1;
            loadFn.call(this);
        },
        reloadProcessList(scope) {
            const pageObj = scope === "all" ? this.allProcPage : this.procPage;
            this.resetPageAndLoad(pageObj, () => this.loadProcessList(scope));
        },
        reloadTodo() {
            this.resetPageAndLoad(this.todoPage, this.loadTodo);
        },
        applyWorkflowListFilters(params, q) {
            if (Array.isArray(q.createdAtRange) && q.createdAtRange.length === 2 && q.createdAtRange[0] && q.createdAtRange[1]) {
                params.createdAtBegin = q.createdAtRange[0];
                params.createdAtEnd = q.createdAtRange[1];
            }
            if (q.relatedPartyRole) {
                params.relatedPartyRole = q.relatedPartyRole;
            }
            if (q.relatedPartyId) {
                params.relatedPartyId = q.relatedPartyId;
            }
            if (q.currentHandlerId != null && q.currentHandlerId !== "") {
                params.currentHandlerId = q.currentHandlerId;
            }
            const rk = (q.remarkKeyword || "").trim();
            if (rk) {
                params.remarkKeyword = rk;
            }
        },
        onListFilterRelatedPartyRoleChange(scope) {
            const q = scope === "all" ? this.allProcQuery : this.procQuery;
            this.$set(q, "relatedPartyId", null);
            this.listFilterRelatedPartyOptions = [];
            this.loadListFilterRelatedParties(q);
            this.reloadProcessList(scope);
        },
        loadListFilterRelatedParties(queryState) {
            if (!queryState || !queryState.relatedPartyRole) {
                this.listFilterRelatedPartyOptions = [];
                return;
            }
            this.listFilterRelatedPartyLoading = true;
            getWorkflowRelatedParties({
                role: queryState.relatedPartyRole,
                _hideLoading: true,
            })
                .then((res) => {
                    this.listFilterRelatedPartyOptions = res.data || [];
                })
                .finally(() => {
                    this.listFilterRelatedPartyLoading = false;
                });
        },
        /** scope: 'all' | 'mine' */
        loadProcessList(scope) {
            const isAll = scope === "all";
            const q = isAll ? this.allProcQuery : this.procQuery;
            const pageObj = isAll ? this.allProcPage : this.procPage;
            if (isAll) {
                this.allProcLoading = true;
            } else {
                this.procLoading = true;
            }
            const params = {
                current: pageObj.current,
                size: pageObj.size,
                _hideLoading: true
            };
            if (isAll) {
                if (this.allProcQuery.initiatorId != null && this.allProcQuery.initiatorId !== "") {
                    params.initiatorId = this.allProcQuery.initiatorId;
                }
                if (Array.isArray(this.allProcQuery.statusList) && this.allProcQuery.statusList.length) {
                    params.status = this.allProcQuery.statusList;
                }
                if (this.allProcQuery.tag) {
                    params.tag = this.allProcQuery.tag;
                }
                params.excludeTempSave = true;
            } else {
                const user = LocalStorage.get(USER_INFO) || {};
                if (user.id != null && user.id !== "") {
                    params.initiatorId = user.id;
                }
                if (Array.isArray(this.procQuery.statusList) && this.procQuery.statusList.length) {
                    params.status = this.procQuery.statusList;
                }
            }
            this.applyWorkflowListFilters(params, q);
            getWorkflowProcessList(params)
                .then((res) => {
                    const page = res.data || {};
                    const records = page.records || [];
                    const total = page.total != null ? page.total : 0;
                    if (isAll) {
                        this.allProcList = records;
                        this.allProcPage.total = total;
                    } else {
                        this.procList = records;
                        this.procPage.total = total;
                    }
                })
                .finally(() => {
                    if (isAll) {
                        this.allProcLoading = false;
                    } else {
                        this.procLoading = false;
                    }
                });
        },
        /** 我发起的 + 当前在「全部」页时同步刷新全部列表 */
        refreshWorkflowProcessGrids() {
            this.loadProcessList("mine");
            if (this.activeTab === "all") {
                this.loadProcessList("all");
            }
        },
        loadTodo() {
            this.todoLoading = true;
            getWorkflowTaskTodo({
                current: this.todoPage.current,
                size: this.todoPage.size,
                _hideLoading: true
            })
                .then((res) => {
                    const page = res.data || {};
                    this.todoList = page.records || [];
                    this.todoPage.total = page.total != null ? page.total : 0;
                })
                .finally(() => {
                    this.todoLoading = false;
                });
        },
        openCreate() {
            this.$bus.$emit(SHOW_WORKFLOW_CREATE_MODAL, {
                onSuccess: () => this.refreshWorkflowProcessGrids()
            });
        },
        onRelatedPartyRoleChange() {
            this.$set(this.processForm, "relatedPartyId", null);
            this.$set(this.processForm, "relatedPartyName", null);
            this.relatedPartyOptions = [];
            this.loadRelatedPartiesForRole();
        },

        loadRelatedPartiesForRole() {
            if (!this.processForm.relatedPartyRole) {
                this.relatedPartyOptions = [];
                return;
            }
            this.relatedPartySearchLoading = true;
            getWorkflowRelatedParties({
                role: this.processForm.relatedPartyRole,
                _hideLoading: true,
            })
                .then((res) => {
                    this.relatedPartyOptions = res.data || [];

                })
                .finally(() => {
                    this.relatedPartySearchLoading = false;
                });
        },
        onProcessAssigneeChange(id) {
            const u = this.adminOptions.find((x) => x.id === id);
            this.processForm.firstAssigneeName = u ? u.name || u.username : "";
        },
        buildProcessUpdateBody(targetStatus) {
            const body = {
                questionTitle: this.processForm.questionTitle,
                questionDescription: this.processForm.questionDescription,
                tag: this.processForm.tag,
                questionAttachments: this.processForm.questionAttachments && this.processForm.questionAttachments.length
                    ? this.processForm.questionAttachments
                    : null,
                bizAttachments:
                    this.processForm.bizAttachments && this.processForm.bizAttachments.length
                        ? this.processForm.bizAttachments
                        : null,
                firstAssigneeId: this.processForm.firstAssigneeId,
                firstAssigneeName: this.processForm.firstAssigneeName || null,
                deadline: this.processForm.deadline || null,
                relatedPartyRole: this.processForm.relatedPartyRole,
                relatedPartyId: this.processForm.relatedPartyId || null
            };
            if (targetStatus) {
                body.status = targetStatus;
            }
            if (body.relatedPartyId) {
                const item = this.relatedPartyOptions.find((x) => String(x.relatedPartyId) === String(this.processForm.relatedPartyId));
                body.relatedPartyName = item && item.relatedPartyName ? item.relatedPartyName : null;
            }
            return body;
        },
        doUpdateProcess(targetStatus) {
            if (!this.editingProcessId) return;
            const body = this.buildProcessUpdateBody(targetStatus);
            body.id = this.editingProcessId;
            const isDraftSave = targetStatus === "TEMP_SAVE";
            const loadingKey = isDraftSave ? "processTempSaveSubmitting" : "processSubmitting";
            this[loadingKey] = true;
            updateWorkflowProcess(body)
                .then(() => {
                    this.$message.success(
                        isDraftSave ? "暂存成功" : this.editingProcessIsTempSave ? "提交成功" : "保存成功"
                    );
                    this.processDialogVisible = false;
                    this.refreshWorkflowProcessGrids();
                    if (
                        this.detailVisible &&
                        this.detail &&
                        this.detail.process &&
                        this.detail.process.id === this.editingProcessId
                    ) {
                        this.openDetail(this.editingProcessId);
                    }
                })
                .finally(() => {
                    this[loadingKey] = false;
                });
        },
        submitProcessTempSave() {
            this.doUpdateProcess("TEMP_SAVE");
        },
        submitProcess() {
            this.$refs.processForm.validate((ok) => {
                if (!ok) return;
                const targetStatus = this.editingProcessIsTempSave ? "PENDING" : undefined;
                this.doUpdateProcess(targetStatus);
            });
        },
        openDetail(id) {
            this.taskTreeDetailTask = null;
            this.detailVisible = true;
            this.detail = null;
            this.detailLoading = true;
            getWorkflowProcessDetail(id, { _hideLoading: true })
                .then((res) => {
                    this.detail = res.data;
                })
                .finally(() => {
                    this.detailLoading = false;
                });
        },
        openProcessLogs(row) {
            if (!row || !row.id) return;
            const no = row.processNo ? `操作日志 · ${row.processNo}` : "操作日志";
            this.processLogTitle = no;
            this.processLogVisible = true;
            this.processLogs = [];
            this.processLogLoading = true;
            getWorkflowProcessDetail(row.id, { _hideLoading: true })
                .then((res) => {
                    const data = res.data || {};
                    this.processLogs = Array.isArray(data.logs) ? data.logs : [];
                })
                .finally(() => {
                    this.processLogLoading = false;
                });
        },
        openEdit(row) {
            this.editingProcessId = row.id;
            this.processDialogVisible = true;
            this.processForm = _.cloneDeep(row);
            if (this.processForm.status === "TEMP_SAVE" && !this.processForm.deadline) {
                this.processForm.deadline = this.defaultWorkflowDeadline();
            }
            if (this.processForm.relatedPartyRole) {
                this.loadRelatedPartiesForRole();
            }
            this.$nextTick(() => this.$refs.processForm && this.$refs.processForm.clearValidate());
        },
        onCompleteEnableNextChange(val) {
            if (val) {
                this.$set(this.completeForm, "handleType", null);
                this.$set(this.completeForm, "handleBizId", "");
                this.$set(this.completeForm, "goOnByMyselfIfHasNextTask", false);
            }
        },
        onCompleteHandleTypeChange() {
            this.$set(this.completeForm, "handleBizId", "");
        },
        openComplete(row) {
            this.completeCtx.task = row;
            const nextDl = (row && row.deadline) || this.defaultWorkflowDeadline();
            this.completeHandleTypeOpts = [];
            this.completeForm = {
                resultComment: "",
                resultAttachments: [],
                resultBizAttachments: [],
                handleType: null,
                handleBizId: "",
                enableNext: false,
                goOnByMyselfIfHasNextTask: false,
                nextAssigneeId: null,
                nextAssigneeName: "",
                nextTitle: "",
                nextDescription: "",
                nextDeadline: nextDl
            };
            this.completeVisible = true;
            if (row && row.processId) {
                getWorkflowHandleTypesByProcessId({
                    processId: row.processId,
                    _hideLoading: true
                }).then((res) => {
                    this.completeHandleTypeOpts = Array.isArray(res.data) ? res.data : [];
                });
            }
        },
        onWorkflowSendNotice() {
            this.$bus.$emit(SHOW_DRIVER_NOTICE_MODAL, {
                callback: (record) => {
                    const id = record && typeof record === "object" ? record.id : record;
                    const sid = id != null && id !== "" ? String(id) : "";
                    this.$set(this.completeForm, "handleBizId", sid);
                }
            });
        },
        onWorkflowOpenPunish() {
            const callback = (punishBillId) => {
                const sid =
                    punishBillId != null && punishBillId !== "" ? String(punishBillId) : "";
                this.$set(this.completeForm, "handleBizId", sid);
            };
            const emitPunishModal = (punishBill) => {
                const payload = { callback };
                if (punishBill) {
                    payload.punishBill = punishBill;
                }
                this.$bus.$emit(SHOW_PUNISH_DIAG, payload);
            };
            const task = this.completeCtx.task;
            const processId = task && task.processId;
            if (!processId) {
                emitPunishModal();
                return;
            }
            getWorkflowPunishBillByProcess(processId)
                .then((billRes) => {
                    emitPunishModal(billRes.data || null);
                })
                .catch(() => {
                    emitPunishModal();
                });
        },
        onNextAssigneeChange(id) {
            const u = this.adminOptions.find((x) => x.id === id);
            this.completeForm.nextAssigneeName = u ? u.name || u.username : "";
        },
        submitComplete() {
            const t = this.completeCtx.task;
            if (!t) return;
            const body = {
                taskId: t.id,
                ...this.completeForm
            };
            if (this.completeForm.enableNext) {
                if (!this.completeForm.nextAssigneeId) {
                    this.$message.warning("请选择下一处理人");
                    return;
                }
                body.nextTask = {
                    assigneeId: this.completeForm.nextAssigneeId,
                    assigneeName: this.completeForm.nextAssigneeName || null,
                    title: this.completeForm.nextTitle || "待处理",
                    description: this.completeForm.nextDescription || null,
                    deadline: this.completeForm.nextDeadline || null,
                    bizAttachments: this.completeForm.bizAttachments && this.completeForm.bizAttachments.length
                        ? this.completeForm.bizAttachments
                        : null
                };
            }
            this.completeSubmitting = true;
            completeWorkflowTask(Toolkit.filterEmpty(body))
                .then(() => {
                    this.$message.success("已提交");
                    this.completeVisible = false;
                    this.loadTodo();
                    this.refreshWorkflowProcessGrids();
                })
                .finally(() => {
                    this.completeSubmitting = false;
                });
        },
        openSplit(row) {
            this.splitCtx.taskId = row.id;
            this.splitCtx.parentDeadline = row.deadline || null;
            const defDl = row.deadline || this.defaultWorkflowDeadline();
            this.splitForm = {
                subTasks: [
                    {
                        assigneeId: null,
                        assigneeName: "",
                        title: "子任务1",
                        description: "",
                        deadline: defDl,
                        bizAttachments: []
                    },
                    {
                        assigneeId: null,
                        assigneeName: "",
                        title: "子任务2",
                        description: "",
                        deadline: defDl,
                        bizAttachments: []
                    }
                ]
            };
            this.splitVisible = true;
        },
        onSubAssigneeChange(row, id) {
            const u = this.adminOptions.find((x) => x.id === id);
            row.assigneeName = u ? u.name || u.username : "";
        },
        addSubTask() {
            const defDl = this.splitCtx.parentDeadline || this.defaultWorkflowDeadline();
            this.splitForm.subTasks.push({
                assigneeId: null,
                assigneeName: "",
                title: "子任务",
                description: "",
                deadline: defDl,
                bizAttachments: []
            });
        },
        removeSubTask(index) {
            if (this.splitForm.subTasks.length <= 2) return;
            this.splitForm.subTasks.splice(index, 1);
        },
        submitSplit() {
            if (this.splitForm.subTasks.length < 2) {
                this.$message.warning("至少两个子任务");
                return;
            }
            for (const s of this.splitForm.subTasks) {
                if (!s.assigneeId) {
                    this.$message.warning("请为每个子任务选择执行人");
                    return;
                }
            }
            const body = {
                taskId: this.splitCtx.taskId,
                subTasks: this.splitForm.subTasks.map((s) => ({
                    assigneeId: s.assigneeId,
                    assigneeName: s.assigneeName || null,
                    title: s.title || "子任务",
                    description: s.description || null,
                    deadline: s.deadline || null,
                    bizAttachments: s.bizAttachments && s.bizAttachments.length ? s.bizAttachments : null
                }))
            };
            this.splitSubmitting = true;
            splitWorkflowTask(body)
                .then(() => {
                    this.$message.success("拆分成功");
                    this.splitVisible = false;
                    this.loadTodo();
                    this.refreshWorkflowProcessGrids();
                })
                .finally(() => {
                    this.splitSubmitting = false;
                });
        }
    }
};
</script>

<style lang="less" scoped>
.workflow-page {
    padding: 12px 16px;

    /* 与 WorkflowProcessListPane 中「我发起的」分页对齐：右下 */
    .pager {
        margin-top: 12px;
        text-align: right;
    }
}

.sec-title {
    margin: 16px 0 8px;
    font-size: 14px;
}

.empty-tip {
    color: #909399;
    font-size: 13px;
}

.task-ctx {
    margin-bottom: 12px;
}

.muted {
    color: #909399;
    font-size: 12px;
}

.complete-deal-type-row {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
}

.complete-deal-type-row__select {
    flex: 1;
    min-width: 0;
}

.complete-handle-biz-id {
    margin-top: 6px;
    font-size: 12px;
}

.workflow-task-tree {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    padding: 8px 0;
}

.workflow-task-tree ::v-deep .el-tree-node__content {
    height: auto;
    min-height: 32px;
    align-items: flex-start;
    padding-top: 6px;
    padding-bottom: 6px;
}

.task-tree-node {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px 10px;
    padding-right: 4px;
    font-size: 13px;
    line-height: 1.5;
    min-width: 0;
}

.task-tree-node__main--overdue {
    color: #f56c6c;
    font-weight: 600;
}

.task-tree-node__assignee--link {
    cursor: pointer;
    color: #409eff;
    text-decoration: underline;
}

.task-tree-node__deadline {
    color: #909399;
    font-size: 12px;
}

.task-tree-node__deadline--overdue {
    color: #f56c6c;
    font-weight: 600;
}

.task-tree-node__detail-btn {
    margin-left: auto;
    flex-shrink: 0;
}

.task-tree-detail-panel {
    margin-top: 16px;
    padding: 12px;
    background: #fafafa;
    border-radius: 4px;
    border: 1px solid #ebeef5;
}

.task-tree-detail-panel__sub {
    font-size: 12px;
    color: #909399;
    font-weight: normal;
    margin-left: 8px;
}

.task-tree-detail-panel__desc {
    margin-top: 8px;
}

.task-tree-detail-panel__text {
    white-space: pre-wrap;
    word-break: break-word;
}

.complete-task-header {
    margin-bottom: 12px;
}

.complete-task-header__title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    line-height: 1.4;
    margin-bottom: 6px;
}

.complete-task-header__meta {
    font-size: 12px;
    color: #909399;
    line-height: 1.5;
}

.complete-task-header__dot {
    margin: 0 6px;
    color: #c0c4cc;
}

.complete-task-header__deadline-overdue {
    color: #f56c6c;
    font-weight: 600;
}

.complete-task-header__deadline-link {
    cursor: pointer;
    color: #409eff;
}

.complete-task-header__deadline-link:hover {
    text-decoration: underline;
}

.complete-task-header__deadline-link.complete-task-header__deadline-overdue {
    color: #f56c6c;
}

.complete-task-source {
    margin-bottom: 4px;
    padding: 10px 12px;
    background: #f5f7fa;
    border-radius: 4px;
    border: 1px solid #ebeef5;
}

.complete-task-source__caption {
    font-size: 12px;
    color: #606266;
    font-weight: 600;
    margin-bottom: 8px;
}

.complete-task-source__desc {
    background: #fff;
}

.complete-task-source__pre {
    white-space: pre-wrap;
    word-break: break-word;
    font-size: 13px;
    line-height: 1.5;
    margin: 0;
}

.complete-task-mode-bar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 24px;
    padding: 10px 12px 8px;
    background: #ecf5ff;
    border: 1px solid #d9ecff;
    border-radius: 4px;
    border-left: 3px solid #409eff;
}

.complete-task-mode-bar__switch {
    flex: 0 1 auto;
    margin-right: 0;
}

.complete-task-mode-bar__checkbox-item {
    flex: 0 1 auto;
    margin-right: 0;
}

.complete-task-mode-bar__checkbox-item ::v-deep .el-form-item__content {
    margin-left: 0 !important;
    line-height: 32px;
}

.complete-task-mode-bar__checkbox {
    white-space: nowrap;
}

.complete-task-mode-bar__caption {
    font-size: 12px;
    color: #606266;
    font-weight: 600;
    margin-bottom: 6px;
}

.complete-task-mode-bar__hint {
    font-size: 12px;
    line-height: 1.45;
    margin-bottom: 4px;
}

.complete-task-mode-bar ::v-deep .el-form-item {
    margin-bottom: 0;
}

.complete-task-feedback-panel {
    margin-top: 14px;
    padding: 12px 12px 4px;
    background: #fafafa;
    border: 1px solid #ebeef5;
    border-radius: 4px;
}

.complete-task-feedback-panel__caption {
    font-size: 12px;
    color: #606266;
    font-weight: 600;
    margin-bottom: 12px;
    padding-bottom: 10px;
    border-bottom: 1px solid #e4e7ed;
}
</style>
